// @flow
import React from "react";
import { FormGroup, Label, Input, Col } from "reactstrap";
import { connect } from "react-redux";
import Section from "../../components/Section";
import { updateField } from "../../../redux/actions/configActions";
import PhotoRatio from "./config-form-subsections/PhotoRatio";
import GreenScreenSettings from "./config-form-subsections/GreenScreenSettings";
import MosaicSettings from "./config-form-subsections/MosaicSettings";

import * as Constants from "../../../constants/photoDimensions";
import ImageField from "../../components/ImageField";
import ARSettings from "./config-form-subsections/ARSettings";
import GifSettings from "./GifSettings";
import { getDimensions } from "../../../services/utils";
import SlowMotionSettings from "./SlowMotionSettings";

const mapDispatchToProps = { updateField };
const mapStateToProps = state => {
  const { configReducer } = state;
  return {
    config: configReducer.config,
    files: configReducer.files
  };
};

class PhotoSettings extends React.Component {
  constructor(props) {
    super(props);

    // #region event binders
    this.handleChange = this.handleChange.bind(this);
    this.handleCheckboxChange = this.handleCheckboxChange.bind(this);
    this.handleValidatedFileChange = this.handleValidatedFileChange.bind(this);
    // #endregion
  }
  // #region events

  handleChange(event) {
    this.props.updateField({ [event.target.name]: event.target.value });
  }

  handleCheckboxChange(event) {
    event.persist();
    const { config } = this.props;
    this.props.updateField({
      [event.target.name]: !config[event.target.name]
    });
  }

  handleValidatedFileChange(id, image) {
    this.props.updateField({ [id]: image });
  }

  // #endregion
  render() {
    const { config, files } = this.props;

    const dimensions = config.setting==8? null : getDimensions(config.setting, config.photoRatio);

    const overlays = [1, 2, 3, 4].map(index => (
      <FormGroup row>
        <ImageField
          id={`overlayImage` + index}
          label={`Overlay ` + index}
          required={index === 1}
          image={files[`overlayImage` + index + `File`]}
          {...dimensions}
          onDeleteChange={this.handleCheckboxChange}
          onFileChange={this.handleValidatedFileChange}
        />
      </FormGroup>
    ));

    let activeSettingOptions;
    switch (config.setting) {
      case "2":
        activeSettingOptions = <GifSettings />;
        break;
      case "4":
        activeSettingOptions = <ARSettings />;
        break;
      case "5":
      case "8":
        activeSettingOptions = <GreenScreenSettings />;
        break;
      case "6":
        activeSettingOptions = <MosaicSettings />;
        break;
      case "7":
        activeSettingOptions =  <SlowMotionSettings/>
        break;
      default:
        activeSettingOptions =  null
        break;
    }

    return (
      <React.Fragment>
        <Section title="Photo settings">
          <PhotoRatio />
          {activeSettingOptions}
          <Section title="Overlay images" subsection>
            {overlays}
          </Section>
        </Section>
      </React.Fragment>
    );
  }
}
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PhotoSettings);



// WEBPACK FOOTER //
// ./src/views/Configuration/config-form-sections/PhotoSettings.jsx